import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";

export default function ImagingDyesUseCase() {
  return (
    <>
    <section
      id="imaging-dyes"
      className="min-h-screen pt-[96px] pb-20 px-6 sm:px-8 bg-[#1A1631] text-white scroll-mt-[96px]"
    >
      <div className="max-w-5xl mx-auto space-y-10">

        {/* Back Link */}
        <Link
          to="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          ← Back to main site
        </Link>

        {/* Heading + Intro */}
        <div className="space-y-4">
          <h1 className="sm:text-2xl font-bold bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
            Imaging Dyes
          </h1>
          <p className="text-slate-300 space-y-2">
            Molecular imaging dyes are essential tools for biomedical diagnostics, enabling visualisation of tissues, organs, and cellular processes through fluorescence, phosphorescence, or photoacoustic signals. 
            The development of dyes that are bright, stable, and biologically compatible is critical for advancing real-time imaging, diagnostics, and even image-guided therapy.

            <br /><br />

            In particular, near-infrared (NIR) dyes — which emit in the 650–900 nm range — are gaining traction for their ability to penetrate biological tissue with minimal scattering and autofluorescence. 
            They are ideal for deep-tissue imaging, vascular mapping, and tumor tracking in both preclinical and clinical settings. 
            Yet designing high-performance NIR dyes remains chemically challenging, often requiring precise electronic tuning and aggregation control.
          </p>
        </div>

        {/* How Apoello Helps */}
<div className="space-y-4">
  <h2 className="text-2xl font-semibold text-orange-300">How DiaDEM™ helps</h2>
  <ul className="list-disc list-inside text-slate-300 space-y-2">
    <li>
      Discover dyes with high brightness, low toxicity, and tailored absorption/emission windows for biological imaging.
    </li>
    <li>
      Filter candidates by water solubility, excited-state lifetime indicators, and oscillator strengths.
    </li>
    <li>
      Evaluate Stokes shift and charge localisation to reduce photobleaching and background noise.
    </li>
    <li>
      Order promising imaging probes or precursors directly.
    </li>
  </ul>
</div>

        {/* Why It Matters */}
        <div className="space-y-4">
          <h2 className="text-2xl font-semibold text-orange-300">Why It Matters</h2>
          <p className="text-slate-300 max-w-3xl">
            The path from idea to viable imaging dye is often long, expensive, and uncertain — particularly for NIR fluorophores where trade-offs in brightness, toxicity, and water solubility are complex.
            DiaDEM™ empowers researchers to digitally explore vast chemical spaces, simulate key optical properties, and focus lab work only on the most promising dye candidates — speeding up development for medical imaging, diagnostics, and beyond.
          </p>
        </div>

        {/* CTA Button */}
        <div className="pt-8">
          <Link
            to="/diadem-overview"
            className="inline-block px-6 py-3 bg-[#EF7C34] text-white rounded-xl font-medium hover:bg-[#F89B3F] transition"
          >
            Explore the DiaDEM™ Platform →
          </Link>
        </div>

      </div>
    </section>
          {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}
